import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { JobsFn } from '../api/getJobs'

import AOS from 'aos'
import 'aos/dist/aos.css'

interface JobsProps {
 t_id: number
 t_number: number
 t_cliente_name: string
 t_title: string
 t_link: string
 t_name: string
 t_seo: string
 t_aos: string
}

export function Jobs() {
 useEffect(() => {
  AOS.init()
 }, [])

 const { data: jobs } = useQuery<JobsProps[]>({
  queryKey: ['jobs'],
  queryFn: JobsFn,
  staleTime: 1000 * 60 * 60 * 24 // 1 dia
 })

 return (
  <div className="flex flex-wrap">
   {jobs
    ?.filter(jobNumber => jobNumber.t_number === 9)
    .map(job => {
     return (
      <div className="w-full h-auto" key={job.t_id}>
       <div className="group no-hover-filter" data-aos={job.t_aos}>
        <a href={`/${job.t_link}`} className="relative block">
         <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
          {job.t_cliente_name}
         </h2>
         <span className="font-['rns-milesblack'] font-bold text-lg text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
          {job.t_title}
         </span>
         <div className="relative w-full aspect-[1168/390] max-[768px]:aspect-square">
          <img
           src={`https://www.admancriativa.com.br/assets/img/trabalhos/${job.t_name}`}
           alt={job.t_seo}
           title={job.t_seo}
           className="object-cover group-hover:grayscale group-hover:brightness-50 w-full h-full absolute inset-0"
          />
         </div>
        </a>
       </div>
      </div>
     )
    })}
   {jobs?.some(jobNumber => jobNumber.t_number === 1) && (
    <div className="w-full flex flex-wrap">
     {jobs
      .filter(jobNumber => jobNumber.t_id === 1)
      .map(job => {
       return (
        <div
         className="group no-hover-filter w-full sm:w-full md:w-1/3 lg:w-1/3"
         data-aos={job.t_aos}
         key={job.t_id}
        >
         <a href={`/${job.t_link}`} className="relative block">
          <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
           {job.t_cliente_name}
          </h2>
          <span className="font-['rns-milesblack'] font-bold text-lg text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
           {job.t_title}
          </span>
          <div className="relative w-full h-auto aspect-square">
           <img
            src={`https://www.admancriativa.com.br/assets/img/trabalhos/${job.t_name}`}
            alt={job.t_seo}
            title={job.t_seo}
            className="object-cover group-hover:grayscale group-hover:brightness-50"
           />
          </div>
         </a>
        </div>
       )
      })}
     {jobs
      .filter(jobNumber => jobNumber.t_id === 2)
      .map(job => {
       return (
        <div
         className="group no-hover-filter w-full sm:w-full md:w-2/3 lg:w-2/3"
         data-aos={job.t_aos}
         key={job.t_id}
        >
         <a href={`/${job.t_link}`} className="relative block">
          <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
           {job.t_cliente_name}
          </h2>
          <span className="font-['rns-milesblack'] font-bold text-lg text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
           {job.t_title}
          </span>
          <div className="relative w-full h-auto max-w-[779px] aspect-[779/389] max-[768px]:aspect-square">
           <img
            src={`https://www.admancriativa.com.br/assets/img/trabalhos/${job.t_name}`}
            alt={job.t_seo}
            title={job.t_seo}
            className="object-cover group-hover:grayscale group-hover:brightness-50 w-full h-full absolute inset-0"
           />
          </div>
         </a>
        </div>
       )
      })}
    </div>
   )}
   {jobs
    ?.filter(jobNumber => jobNumber.t_number === 2)
    .map(job => {
     return (
      <div className="w-full h-auto" key={job.t_id}>
       <div className="group no-hover-filter" data-aos={job.t_aos}>
        <a href={`/${job.t_link}`} className="relative block">
         <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
          {job.t_cliente_name}
         </h2>
         <span className="font-['rns-milesblack'] font-bold text-lg text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
          {job.t_title}
         </span>
         <div className="relative w-full aspect-[1168/390] max-[768px]:aspect-square">
          <img
           src={`https://www.admancriativa.com.br/assets/img/trabalhos/${job.t_name}`}
           alt={job.t_seo}
           title={job.t_seo}
           className="object-cover group-hover:grayscale group-hover:brightness-50 w-full h-full absolute inset-0"
          />
         </div>
        </a>
       </div>
      </div>
     )
    })}
   {jobs?.some(jobNumber => jobNumber.t_number === 3) && (
    <div className="w-full flex flex-wrap">
     {jobs
      .filter(jobNumber => jobNumber.t_id === 4)
      .map(job => {
       return (
        <div
         className="group no-hover-filter w-full sm:w-full md:w-1/3 lg:w-1/3"
         data-aos={job.t_aos}
         key={job.t_id}
        >
         <a href={`/${job.t_link}`} className="relative block">
          <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
           {job.t_cliente_name}
          </h2>
          <span className="font-['rns-milesblack'] font-bold text-lg text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
           {job.t_title}
          </span>
          <div className="relative w-full h-auto aspect-square">
           <img
            src={`https://www.admancriativa.com.br/assets/img/trabalhos/${job.t_name}`}
            alt={job.t_seo}
            title={job.t_seo}
            className="object-cover group-hover:grayscale group-hover:brightness-50 w-full h-full absolute inset-0"
           />
          </div>
         </a>
        </div>
       )
      })}
     {jobs
      .filter(jobNumber => jobNumber.t_id === 5)
      .map(job => {
       return (
        <div
         className="group no-hover-filter w-full sm:w-full md:w-1/3 lg:w-1/3"
         data-aos={job.t_aos}
         key={job.t_id}
        >
         <a href={`/${job.t_link}`} className="relative block">
          <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
           {job.t_cliente_name}
          </h2>
          <span className="font-['rns-milesblack'] font-bold text-lg text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
           {job.t_title}
          </span>
          <div className="relative w-full h-auto aspect-square">
           <img
            src={`https://www.admancriativa.com.br/assets/img/trabalhos/${job.t_name}`}
            alt={job.t_seo}
            title={job.t_seo}
            className="object-cover group-hover:grayscale group-hover:brightness-50 w-full h-full absolute inset-0"
           />
          </div>
         </a>
        </div>
       )
      })}
     {jobs
      .filter(jobNumber => jobNumber.t_id === 6)
      .map(job => {
       return (
        <div
         className="group no-hover-filter w-full sm:w-full md:w-1/3 lg:w-1/3"
         data-aos={job.t_aos}
         key={job.t_id}
        >
         <a href={`/${job.t_link}`} className="relative block">
          <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
           {job.t_cliente_name}
          </h2>
          <span className="font-['rns-milesblack'] font-bold text-lg text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
           {job.t_title}
          </span>
          <div className="relative w-full h-auto aspect-square">
           <img
            src={`https://www.admancriativa.com.br/assets/img/trabalhos/${job.t_name}`}
            alt={job.t_seo}
            title={job.t_seo}
            className="object-cover group-hover:grayscale group-hover:brightness-50 w-full h-full absolute inset-0"
           />
          </div>
         </a>
        </div>
       )
      })}
    </div>
   )}
   {jobs?.some(jobNumber => jobNumber.t_number === 4) && (
    <div className="w-full flex flex-wrap">
     {jobs
      .filter(jobNumber => jobNumber.t_id === 7)
      .map(job => {
       return (
        <div
         className="group no-hover-filter w-full sm:w-full md:w-2/3 lg:w-2/3"
         data-aos={job.t_aos}
         key={job.t_id}
        >
         <a href={`/${job.t_link}`} className="relative block">
          <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
           {job.t_cliente_name}
          </h2>
          <span className="font-['rns-milesblack'] font-bold text-lg text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
           {job.t_title}
          </span>
          <div className="relative w-full h-auto max-w-[779px] aspect-[779/389] max-[768px]:aspect-square">
           <img
            src={`https://www.admancriativa.com.br/assets/img/trabalhos/${job.t_name}`}
            alt={job.t_seo}
            title={job.t_seo}
            className="object-cover group-hover:grayscale group-hover:brightness-50 w-full h-full absolute inset-0"
           />
          </div>
         </a>
        </div>
       )
      })}
     {jobs
      .filter(jobNumber => jobNumber.t_id === 8)
      .map(job => {
       return (
        <div
         className="group no-hover-filter w-full sm:w-full md:w-1/3 lg:w-1/3"
         data-aos={job.t_aos}
         key={job.t_id}
        >
         <a href={`/${job.t_link}`} className="relative block">
          <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
           {job.t_cliente_name}
          </h2>
          <span className="font-['rns-milesblack'] font-bold text-lg text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
           {job.t_title}
          </span>
          <div className="relative w-full h-auto aspect-square">
           <img
            src={`https://www.admancriativa.com.br/assets/img/trabalhos/${job.t_name}`}
            alt={job.t_seo}
            title={job.t_seo}
            className="object-cover group-hover:grayscale group-hover:brightness-50 w-full h-full absolute inset-0"
           />
          </div>
         </a>
        </div>
       )
      })}
    </div>
   )}
   {jobs
    ?.filter(jobNumber => jobNumber.t_number === 5)
    .map(job => {
     return (
      <div className="w-full h-auto" key={job.t_id}>
       <div className="group no-hover-filter" data-aos={job.t_aos}>
        <a href={`/${job.t_link}`} className="relative block">
         <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
          {job.t_cliente_name}
         </h2>
         <span className="font-['rns-milesblack'] font-bold text-lg text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
          {job.t_title}
         </span>
         <div className="relative w-full aspect-[1168/390] max-[768px]:aspect-square">
          <img
           src={`https://www.admancriativa.com.br/assets/img/trabalhos/${job.t_name}`}
           alt={job.t_seo}
           title={job.t_seo}
           className="object-cover group-hover:grayscale group-hover:brightness-50 w-full h-full absolute inset-0"
          />
         </div>
        </a>
       </div>
      </div>
     )
    })}
   {jobs?.some(jobNumber => jobNumber.t_number === 6) && (
    <div className="w-full flex flex-wrap">
     {jobs
      .filter(jobNumber => jobNumber.t_id === 9)
      .map(job => {
       return (
        <div
         className="group no-hover-filter w-full sm:w-full md:w-1/3 lg:w-1/3"
         data-aos={job.t_aos}
         key={job.t_id}
        >
         <a href={`/${job.t_link}`} className="relative block">
          <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
           {job.t_cliente_name}
          </h2>
          <span className="font-['rns-milesblack'] font-bold text-lg text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
           {job.t_title}
          </span>
          <div className="relative w-full h-auto aspect-square">
           <img
            src={`https://www.admancriativa.com.br/assets/img/trabalhos/${job.t_name}`}
            alt={job.t_seo}
            title={job.t_seo}
            className="object-cover group-hover:grayscale group-hover:brightness-50 w-full h-full absolute inset-0"
           />
          </div>
         </a>
        </div>
       )
      })}
     {jobs
      .filter(jobNumber => jobNumber.t_id === 10)
      .map(job => {
       return (
        <div
         className="group no-hover-filter w-full sm:w-full md:w-2/3 lg:w-2/3"
         data-aos={job.t_aos}
         key={job.t_id}
        >
         <a href={`/${job.t_link}`} className="relative block">
          <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
           {job.t_cliente_name}
          </h2>
          <span className="font-['rns-milesblack'] font-bold text-lg text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
           {job.t_title}
          </span>
          <div className="relative w-full h-auto max-w-[779px] aspect-[779/389] max-[768px]:aspect-square">
           <img
            src={`https://www.admancriativa.com.br/assets/img/trabalhos/${job.t_name}`}
            alt={job.t_seo}
            title={job.t_seo}
            className="object-cover group-hover:grayscale group-hover:brightness-50 w-full h-full absolute inset-0"
           />
          </div>
         </a>
        </div>
       )
      })}
    </div>
   )}
   {jobs?.some(jobNumber => jobNumber.t_number === 7) && (
    <div className="w-full flex flex-wrap">
     {jobs
      .filter(jobNumber => jobNumber.t_id === 11)
      .map(job => {
       return (
        <div
         className="group no-hover-filter w-full sm:w-full md:w-2/3 lg:w-2/3"
         data-aos={job.t_aos}
         key={job.t_id}
        >
         <a href={`/${job.t_link}`} className="relative block">
          <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
           {job.t_cliente_name}
          </h2>
          <span className="font-['rns-milesblack'] font-bold text-lg text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
           {job.t_title}
          </span>
          <div className="relative w-full h-auto max-w-[779px] aspect-[779/389] max-[768px]:aspect-square">
           <img
            src={`https://www.admancriativa.com.br/assets/img/trabalhos/${job.t_name}`}
            alt={job.t_seo}
            title={job.t_seo}
            className="object-cover group-hover:grayscale group-hover:brightness-50 w-full h-full absolute inset-0"
           />
          </div>
         </a>
        </div>
       )
      })}
     {jobs
      .filter(jobNumber => jobNumber.t_id === 12)
      .map(job => {
       return (
        <div
         className="group no-hover-filter w-full sm:w-full md:w-1/3 lg:w-1/3"
         data-aos={job.t_aos}
         key={job.t_id}
        >
         <a href={`/${job.t_link}`} className="relative block">
          <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
           {job.t_cliente_name}
          </h2>
          <span className="font-['rns-milesblack'] font-bold text-lg text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
           {job.t_title}
          </span>
          <div className="relative w-full h-auto aspect-square">
           <img
            src={`https://www.admancriativa.com.br/assets/img/trabalhos/${job.t_name}`}
            alt={job.t_seo}
            title={job.t_seo}
            className="object-cover group-hover:grayscale group-hover:brightness-50 w-full h-full absolute inset-0"
           />
          </div>
         </a>
        </div>
       )
      })}
    </div>
   )}
   {jobs
    ?.filter(jobNumber => jobNumber.t_number === 8)
    .map(job => {
     return (
      <div className="w-full h-auto" key={job.t_id}>
       <div className="group no-hover-filter" data-aos={job.t_aos}>
        <a href={`/${job.t_link}`} className="relative block">
         <h2 className="font-['rns-milesblack'] font-bold text-base text-white uppercase tracking-[2px] absolute top-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 title">
          {job.t_cliente_name}
         </h2>
         <span className="font-['rns-milesblack'] font-bold text-lg text-white absolute bottom-7 right-2 left-2 z-10 opacity-0 group-hover:opacity-100 max-[992px]:opacity-100 subtitle">
          {job.t_title}
         </span>
         <div className="relative w-full aspect-[1168/390] max-[768px]:aspect-square">
          <img
           src={`https://www.admancriativa.com.br/assets/img/trabalhos/${job.t_name}`}
           alt={job.t_seo}
           title={job.t_seo}
           className="object-cover group-hover:grayscale group-hover:brightness-50 w-full h-full absolute inset-0"
          />
         </div>
        </a>
       </div>
      </div>
     )
    })}
  </div>
 )
}
